import { type GetStatusResponse } from '../../../common/types';

export const transformStatusResponse = ({
	currentTimeUtcMillis,
	onCallUntilUtcMillis,
	onCallUntilOffsetMillis,
	isCurrentOnCall,
	isParticipantOfAnyRotation,
	nextOnCallEndUtcMillis,
	nextOnCallEndOffsetMillis,
	nextOnCallStartUtcMillis,
	nextOnCallStartOffsetMillis,
}: GetStatusResponse) => {
	return {
		currentDate: currentTimeUtcMillis,
		currentShiftEnd: onCallUntilUtcMillis,
		currentShiftEndOffset: onCallUntilOffsetMillis,
		isOnCall: isCurrentOnCall,
		isParticipantOfAnyRotation: isParticipantOfAnyRotation,
		nextEndDate: nextOnCallEndUtcMillis,
		nextEndOffset: nextOnCallEndOffsetMillis,
		nextStartDate: nextOnCallStartUtcMillis,
		nextStartOffset: nextOnCallStartOffsetMillis,
	};
};
